<!-- MODAL ver pedido -->
<div mdbModal #verResultado="mdb-modal" class="modal fade" style="overflow-y: auto;" id="basicExample" tabindex="-1"
  role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Resultado operación
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="verResultado.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <!-- <div class="row" style="border-bottom: 1px solid #dee2e6;">
                    <div class="col">
                        <h5 class="modal-title w-100 text-left" id="myModalLabel">
                            Resultados correctos
                        </h5>
                    </div>
                </div> -->

        <div class="row">
          <div class="col mt-1">
            <div class="table-responsive">
              <table class="table table-striped table-hover table-sm align-middle" *ngIf="successDataAll">
                <thead class="grey lighten-2">
                  <tr>
                    <th scope="col" class="text-center">Nota Vta.</th>
                    <!-- <th scope="col" class="text-center">Descripción</th> -->
                    <!-- <th scope="col" class="text-center">Unidad</th>
                                        <th scope="col" class="text-center">Cantidad</th>
                                        <th scope="col" class="text-center">Precio Unit.</th>
                                        <th scope="col" class="text-center">IVA</th> -->
                    <th scope="col" class="text-center">Rut</th>
                    <th scope="col" class="text-center">Cliente</th>
                    <th scope="col" class="text-center">Total</th>
                    <th scope="col" class="text-center">Obs.</th>
                    <th scope="col" class="text-center"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngIf="successDataAll?.length === 0">
                    <td colspan="100%" style="text-align: center">
                      No se encontró información
                    </td>
                  </tr>
                  <tr *ngFor="let record of successData">
                    <td class="text-center">{{record.cabecera?.folio>0?record.cabecera?.folio:''}}
                    </td>
                    <!-- <td class="text-center">{{record.detalle?.nombreProducto}}</td> -->
                    <!-- <td class="text-center">{{record.detalle?.formato_codigo}}</td>
                                        <td class="text-center">{{record.detalle? (record.detalle.cantidad | numerico) : ''}}</td>
                                        <td class="text-center">$ {{record.detalle? (record.detalle.precio_unitario | numerico) : ''}}</td>
                                        <td class="text-center">$ {{record.detalle? (record.detalle.monto_iva | numerico) : ''}}</td> -->
                    <!-- <td class="text-center">$ {{record.detalle? (record.detalle.monto_total | numerico) : ''}}</td> -->
                    <td class="text-center">{{record.cabecera?.rutFormato | rut}}</td>
                    <td class="text-center"
                        [mdbTooltip]="record.cabecera?.nombrecliente"
                        placement="top">
                      {{record.cabecera?.nombrecliente | slice:0:25}}{{(record.cabecera?.nombrecliente?.length > 25) ? '...' : ''}}
                    </td>
                    <td class="text-center">
                      <ng-container *ngIf="record.pedidoConvertido; else sinTotal">
                        $ {{record.cabecera?.totalBruto | numerico}}
                      </ng-container>
                      <ng-template #sinTotal>-</ng-template>
                    </td>
                    <td class="text-center">
                      <ng-container *ngIf="record.pedidoConvertido; else conErrores">
                        <mdb-icon fas icon="check-circle" class="text-success"
                                  mdbTooltip="Sin errores" placement="top">
                        </mdb-icon>
                      </ng-container>
                      <ng-template #conErrores>
                        <ng-container *ngIf="record.logErrores?.length > 0">
                          <mdb-icon fas icon="exclamation-circle" class="text-danger mr-1"
                                    placement="top">
                          </mdb-icon>
                          <span class="text-danger small"
                                [mdbTooltip]="record.logErrores[0].texto"
                                placement="top"
                                style="user-select: none; cursor: default;">
                            {{record.logErrores[0].texto | slice:0:40}}{{(record.logErrores[0].texto?.length > 40) ? '...' : ''}}
                          </span>
                        </ng-container>
                      </ng-template>
                    </td>
                    <td class="text-center" style="cursor: pointer;">
                      <ng-container *ngIf="!record.pedidoConvertido">
                        <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
                          mdbTooltip="Ver" placement="right" (click)="showErrores(record.logErrores)">
                          <mdb-icon fas icon="eye"></mdb-icon>
                        </button>
                      </ng-container>
                    </td>
                  </tr>
                </tbody>
                <app-pagination *ngIf="successDataAll?.length > 0" [context]="paginationContextSuccess"
                  (onPageChange)="onPageChangeSuccess($event)"></app-pagination>
              </table>
              <table class="table table-striped table-hover table-sm align-middle">
                <tbody style="text-align:right;">
                  <tr>
                    <td class="col-8" style="font-weight: bold; font-size: 15px;">
                      <span style="color: red;">Total Neto </span>
                      <span>$ {{sumMontoNeto | numerico}}</span>
                    </td>
                    <td class="col-4" style="font-weight: bold; font-size: 15px;">
                      <span style="color: red;">Total Bruto </span>
                      <span>$ {{sumMontoBruto | numerico}}</span>
                    </td>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer justify-content-between">
        <button type="button" class="btn btn-default waves-light" data-dismiss="modal" (click)="verResultado.hide()"
          mdbWavesEffect>
          Cerrar
        </button>

        <button *ngIf="successDataAll?.length > 0 && thereIsAtLeastOneOk" mdbBtn type="button" color="success"
          mdbWavesEffect (click)="navigateToAnalisisDeDemanda()">
          Ir a Análisis de demanda
          <!-- Paso siguiente -->
          <mdb-icon fas icon="arrow-right"></mdb-icon>
        </button>
      </div>
    </div>
  </div>
</div>

<app-modal-ver-errores></app-modal-ver-errores>